import React from 'react'
import { ProductUpdate } from '../features/admin/components/ProductUpdate'
import {Navbar} from '../features/navigation/components/Navbar'

export const ProductUpdatePage = () => {
  return (
    <>
    <Navbar/>
    <div className='pt-[55px]'>
    <ProductUpdate/>
    </div>
    
    </>
  )
}
